import React, { memo, useMemo } from "react";
import "./index.css";
import moment from "moment";
import DOMPurify from 'dompurify';
import stringHelper from "../../../helpers/StringHelper";
import MidiaSocialIcone from "../../../components/MidiaSocialIcone";

export const CardEnviado = memo(({item, mensagemSelecionada, setMensagemSelecionada, conteudoAtendimentoSelecionado, handleSelecionarAtendimento})=>{
  const detalhes = JSON.parse(item.detalhes);

  const dados = useMemo(() => {
    return stringHelper.htmlToText(item?.conteudo ?? '');
  },[item])


  return(
    <div 
      className={`card-enviado ${mensagemSelecionada?.id === item.id ? 'selecionado' : ''}`} 
      onClick={()=>{
        setMensagemSelecionada(item.id === mensagemSelecionada?.id ? null : item);
      }} 
    >
      <div className="enviado-section">
        <span className="remetente-label">
          <input 
            type="checkbox"
            checked={conteudoAtendimentoSelecionado}
            onClick={(event)=>{
              event.stopPropagation();
              handleSelecionarAtendimento(item.id)
            }}
          />
          <div className='icon-meio_comunicao'>
              <MidiaSocialIcone midia={item.slug_meio_comunicacao || null} />
          </div>
          {detalhes?.data?.to}
        </span>
        <span className="data-label">
          {moment(item.criado_em).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      </div>
      <div className="detalhes-section">
        <span className="assunto-label" data-tip={detalhes?.data?.assunto}>
          {detalhes?.data?.assunto}
        </span>
        <div data-tip={dados} className="detalhes-label" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(dados) }}/>
      </div>
    </div>
  )
})

